<template>
  <div class="container">
     <content-title :nav="nav"></content-title>
    <el-form :inline="true">
    
      <el-form-item label="名称">
         <el-input v-model="query.name"></el-input>
      </el-form-item>
      
      <el-form-item label="型号">
         <el-input v-model="query.model_no"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>

    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
     <template #type="{ row }">
        <div>
          {{ getNameByValue(deviceCode, row.type) }}
        </div>
      </template>
      <template #handle="{ row }">
         <el-button size="small" @click="openUpdate(row)" type="success"
          >编辑</el-button
        >
      </template>
    </auto-table>

<addEdit ref="edit" @success="getList(1)"></addEdit>
  </div>
</template>

<script>
import addEdit from './components/produce/addEdit.vue';
import { deviceCode } from "./components/dict";
export default {
    components:{
        addEdit
    },
  data() {
    return {
        nav: { firstNav: "设备中心", secondNav: "设备型号" },
        deviceCode,
      DataList: [],
      query: {
        name: null
      },
      Option: [
        { name: "名称", value: "name" },
        { name: "型号", value: "model_no" },
        { name: "类型", value: "type",type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom"},
      ],
      Total: 0
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    openAdd(){
        this.$refs.edit.open()
    },
    openUpdate(row){
        this.$refs.edit.open(row)
    },
    //列表
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        ...this.query
      };
      this.$axios({
        url: "/device/deviceModel/queryManagerListPage",
        params,
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>